import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deleteProjectElement = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}project_elements/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteProjectElement;
